import { render, staticRenderFns } from "./FoodcourtPedidosList.vue?vue&type=template&id=4e09f185&scoped=true"
import script from "./FoodcourtPedidosList.vue?vue&type=script&lang=js"
export * from "./FoodcourtPedidosList.vue?vue&type=script&lang=js"
import style0 from "./FoodcourtPedidosList.vue?vue&type=style&index=0&id=4e09f185&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e09f185",
  null
  
)

export default component.exports